<template>
    <div id="app">
        <Navigation></Navigation>
        <router-view></router-view>
    </div>
</template>

<script>
import Navigation from './components/Navigation.vue';

export default {
    name: 'app',
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    components: {
        Navigation: Navigation,
    }
}
</script>

<style lang="scss">
    body, html {
        height: 100%;
        overflow: hidden;
    }

    body {
        background-image: url("./assets/background-001.jpg");
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
    }

    #app {
        height: 100%;
    }
</style>
